var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,10A10,10,0,1,0,1.387,15.083l-1.35,4.88,4.88-1.35A10,10,0,0,0,20,10ZM8.465,7.673H6.931a3.069,3.069,0,1,1,5.14,2.265l-1.3,1.193v1.2H9.233V10.455l1.8-1.65a1.519,1.519,0,0,0,.5-1.133,1.535,1.535,0,1,0-3.069,0Zm.767,6.189h1.535V15.4H9.233Zm0,0",
    fill: "#697384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/query.b028a39a453ecdd9ef9f0b9857f8b32b.svg";
export { ForwardRef as ReactComponent };